import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { RTEAlertService } from 'rte-library';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ObjectReportService {

  headers = new HttpHeaders({
    'No-loading': 'True'
  });

  constructor(
    private http: HttpClient,
    private alert: RTEAlertService
  ) { }


  delete(objectId: number) {
    const params = new HttpParams()
                    .set('id', objectId.toString());

    return this.http.delete<boolean>(environment.apiUrl + 'api/objectreport', {headers: this.headers, params});
  }
}
